import {
  Box,
  FlexBox,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { ReactElement } from 'react';

import { useAppNavigate } from 'utils/url/useAppNavigate';

import styles from './restrictedConversation.module.scss';

const circle = (
  <Box className={styles.circle} style={{ flexBasis: 20, flexShrink: 0 }} />
);

const header = (
  <FlexBox
    justifyContent="space-between"
    alignItems="center"
    className={styles.header}
  >
    <FlexBox gap="300" style={{ flexGrow: 1 }}>
      {circle}
      <Box className={styles.circle} style={{ flexBasis: 120 }} />
      <Box className={styles.circle} style={{ flexBasis: 60 }} />
    </FlexBox>
    <FlexBox justifyContent="flex-end" gap="300" style={{ flexGrow: 1 }}>
      <Box
        className={classNames(styles.square, styles.squareVerySmall)}
        style={{ flexShrink: 0 }}
      />
      <Box className={styles.circle} style={{ flexBasis: 60 }} />
      {circle}
      <Box className={styles.circle} style={{ flexBasis: 80 }} />
      {circle}
      <Box className={styles.circle} style={{ flexBasis: 80 }} />
      {circle}
      {circle}
    </FlexBox>
  </FlexBox>
);

const historyItem = <Box className={styles.historyItem} />;

const history = (
  <FlexBox flexDirection="column" gap="200" className={styles.history}>
    {historyItem}
    {historyItem}
    {historyItem}
    {historyItem}
    {historyItem}
  </FlexBox>
);

const message = (
  <FlexBox gap="300">
    <Box className={styles.square} />
    <FlexBox flexDirection="column" gap="200">
      <Box className={styles.messageLine} />
      <Box className={styles.messageLine} />
      <Box className={styles.messageLine} />
      <Box className={styles.messageLine} />
    </FlexBox>
  </FlexBox>
);

const sidebar = (
  <FlexBox className={styles.sidebar}>
    <FlexBox className={styles.sidebarItem} gap="300">
      <Box className={styles.circle} style={{ flexBasis: 120 }} />
      <Box className={styles.circle} />
    </FlexBox>
    <FlexBox className={styles.sidebarItem} gap="300">
      <Box className={classNames(styles.square, styles.squareSmall)} />
      <Box
        className={styles.circle}
        style={{ flexBasis: 120, marginRight: 'auto' }}
      />
      {circle}
      {circle}
    </FlexBox>
    <FlexBox className={styles.sidebarItem} gap="300">
      <Box className={classNames(styles.square, styles.squareSmall)} />
      <Box
        className={styles.circle}
        style={{ flexBasis: 140, marginRight: 'auto' }}
      />
      {circle}
    </FlexBox>
    <FlexBox className={styles.sidebarItem} gap="300">
      <Box className={classNames(styles.square, styles.squareSmall)} />
      <Box
        className={styles.circle}
        style={{ flexBasis: 130, marginRight: 'auto' }}
      />
      {circle}
    </FlexBox>
    <FlexBox className={styles.sidebarItem} gap="300">
      <Box className={styles.circle} style={{ flexBasis: 140 }} />
    </FlexBox>
    <FlexBox className={styles.sidebarItem} gap="300">
      <Box className={classNames(styles.square, styles.squareSmall)} />
      <Box
        className={styles.circle}
        style={{ flexBasis: 130, marginRight: 'auto' }}
      />
      {circle}
    </FlexBox>
  </FlexBox>
);

const divider = (
  <FlexBox gap="400" className={styles.divider}>
    <Box className={styles.dividerItem} />
    <Box className={styles.dividerItem} />
    <Box className={styles.dividerItem} />
  </FlexBox>
);

const messageInput = (
  <FlexBox
    flexDirection="column"
    justifyContent="space-between"
    className={styles.messageInput}
  >
    <Box className={styles.circle} style={{ width: 300 }} />
    <FlexBox gap="300" alignItems="center">
      {circle}
      {circle}
      {circle}
      {circle}
      {circle}
      {circle}
      <Box
        className={styles.square}
        style={{ flexBasis: 70, flexShrink: 0, marginLeft: 'auto' }}
      />
    </FlexBox>
  </FlexBox>
);

export const RestrictedConversation = (): ReactElement => {
  const navigate = useAppNavigate();
  const goBack = () => navigate({ path: '/search/conversations', params: {} });

  const modal = (
    <Modal
      isOpen={true}
      className={styles.modal}
      onClose={goBack}
      allowEscClose={false}
    >
      <ModalHead title="Access denied"></ModalHead>
      <ModalBody>
        You do not have access to view this conversation as it is in a
        restricted queue. Please consult your organization admin to gain access.
      </ModalBody>
      <ModalFoot
        confirmOnClick={goBack}
        confirmName="Confirm"
        cancelOnClick={goBack}
        cancelName="Cancel"
      />
    </Modal>
  );

  return (
    <>
      {modal}
      <FlexBox gap="200" className={styles.conversationContainer}>
        {history}
        <FlexBox flexDirection="column" style={{ flexGrow: 1 }}>
          {header}
          <FlexBox
            flexDirection="column"
            justifyContent="flex-end"
            gap="500"
            className={styles.inboxContainer}
          >
            {message}
            {message}
          </FlexBox>
          {divider}
          {messageInput}
        </FlexBox>
        {sidebar}
      </FlexBox>
    </>
  );
};
